'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getPageTitle, formatDocumentTitle } from '@/lib/config/pageTitles';

export default function DynamicPageTitle() {
  const pathname = usePathname();

  useEffect(() => {
    const pageTitle = getPageTitle(pathname);
    const documentTitle = formatDocumentTitle(pageTitle);

    let attempts = 0;
    const maxAttempts = 5;

    // Set title immediately
    document.title = documentTitle;

    // Check and set title every 400ms for 5 times (total 2 seconds)
    const intervalId = setInterval(() => {
      attempts++;

      if (document.title !== documentTitle) {
        console.log(`[DynamicPageTitle] Attempt ${attempts}: Updating title to "${documentTitle}"`);
        document.title = documentTitle;
      }

      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, 400);

    return () => clearInterval(intervalId);
  }, [pathname]);

  return null;
}